export default __webpack_public_path__ + "static/media/darkLoc.90235cae.svg";